<template>
  <div class="resume-page">
    <div class="product-banner1">
      <div class="banner-info need-padding">
        <span class="title scroll-animate">天空之城</span>
        <div class="banner-description-group scroll-animate">
          <span class="description">这里是我的数字自留地，记录练习、碎片思考与随手创作。无广告，无推送，安静且不打扰。</span>
          <span class="description">一间线上小屋，用来安放所有细碎表达。</span>
        </div>
      </div>
    </div>
    <div class="next-hero">
      <div class="hero-big-description scroll-animate">先看重点</div>
      <!-- 一组：标题+描述打包在一起 -->
      <div class="text-card">
        <div class="text-group-card-wrapper scroll-animate" style="--delay:0.1s">
          <div class="text-group-image">
            <img src="@/assets/whyHave.webp" alt="whyHave">
          </div>
          <div class="text-group-card">
            <div class="hero-description-title">为什么会有这样一个网站？</div>
            <div class="hero-description-subTitle">这是我的个人站点，也是前端学习路上的实践场。
              在这里记录代码、文字与思考，搭建属于我的数字空间。
            </div>
          </div>
        </div>
        <div class="text-group-card-wrapper scroll-animate" style="--delay:0.2s">
          <div class="text-group-image">
            <img src="@/assets/whyName.webp" alt="whyName">
          </div>
          <div class="text-group-card">
            <div class="hero-description-title">为什么取名叫做天空之城？</div>
            <div class="hero-description-subTitle">
              寓意在互联网的浩瀚苍穹之中,有一个属于我自己的精神堡垒。很清静，无人打扰，安安静静的待在这里。
            </div>
          </div>
        </div>
        <div class="text-group-card-wrapper scroll-animate" style="--delay:0.3s">
          <div class="text-group-image">
            <img src="@/assets/whatsMean.webp" alt="whatsMean">
          </div>
          <div class="text-group-card card-1">
            <div class="hero-description-title">网站logo是什么含义？</div>
            <div class="hero-description-subTitle">
              一座漂浮云端的数字小城，在这里存放代码、文字、生活碎片与所有热爱，是互联网上的精神自留地。
            </div>
          </div>
        </div>
      </div>
      <div class="text-card-single">
        <div class="text-group scroll-animate" style="--delay:0.3s">
          <div class="hero-description-subTitle">
            AI浪潮正在重塑开发行业，固守传统Java后端的单一能力，早已不再具备足够竞争力。掌握AI能力的全栈开发者，将成为时代主流。
          </div>
        </div>
      </div>
      <div class="text-card-single">
        <div class="text-group scroll-animate" style="--delay:0.3s">
          <div class="hero-description-title">这里，就是我的出发之地</div>
          <div class="hero-description-subTitle">我以此站为基石，迈出成为AI全栈工程师的第一步</div>
        </div>
      </div>
    </div>

    <!-- 底部引导文字，单独一组 -->
    <div class="guide-group">
      <div class="hero-description hero-big-description scroll-animate" style="--delay:0.3s">
        接下来，看看我的网站都有哪些功能
      </div>
    </div>


    <div class="sub-item">
      <div class="special-card first">
        <div class="special-card-first scroll-animate" style="--delay:0.3s">
          <div class="special-card-up">
            <div class="title">开启专属访问
              <img class="detail-img" src="@/assets/svg/detail.svg" alt="detail" @click="openLoginMask">
            </div>
            <div class="description textBold">
              注册账号，登录空间，忘记密码也可快速重置。
            </div>
            <div class="description">
              身份验证基于Token无状态机制。认证信息封装在令牌中随请求传递，服务端无需保存会话状态,登出即刻失效清除。在保障身份安全的同时，带来流畅轻盈的访问体验。
            </div>
          </div>
          <div class="special-card-down">
            <img class="image" src="../../assets/login.webp" alt="login"/>
          </div>
        </div>
        <div class="special-card-first scroll-animate" style="--delay:0.3s">
          <div class="special-card-up">
            <div class="title">内容工作台 <img class="detail-img" src="@/assets/svg/detail.svg" alt="detail"
                                               @click="openManageMask">
            </div>
            <div class="description textBold">
              书写博客，记录碎片瞬间，用文字留下自己的痕迹。
            </div>
            <div class="description">
              每一篇博客，都是思想的沉淀；每一条时刻，都是生活的注脚。从撰写到发布，从整理到更新，所有创作都在一个地方完成管理，不遗漏任何灵感，不丢失任何瞬间。
            </div>
          </div>
          <div class="special-card-down">
            <img class="image" src="../../assets/manage.webp" alt="manage"/>
          </div>
        </div>
      </div>
    </div>
    <Teleport to="body">
      <div class="mask glass" v-if="login" @click.self="login=false">
        <!-- 弹窗卡片容器 -->
        <div class="mask-body">
          <!-- 右上角关闭按钮 -->
          <button class="mask-close-btn" @click="login=false">
            <img class="detail-img" src="@/assets/svg/close.svg" alt="close"/>
          </button>
          <div class="mask-top-label">登陆</div>
          <h2 class="mask-main-title">简单、方便、快速。</h2>
          <div class="mask-cards">
            <div class="mask-card">
              <div class="tips">
                双令牌 JWT 认证
              </div>
              <div class="mask-text-block">
                <p>采用 AccessToken + RefreshToken 分离设计。短期 AccessToken 携带身份、角色信息，用于每次接口鉴权；长效
                  RefreshToken 用于无感续期，避免频繁登录。JWT 无状态，服务端不存储会话，登出通过 Redis
                  黑名单实现令牌失效。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/refresh.webp" alt="refresh"/>
              </div>
            </div>
            <div class="mask-card">
              <div class="tips">HttpOnly Cookie 防护</div>
              <div class="mask-text-block">
                <p>RefreshToken 存放于 HttpOnly Cookie，浏览器 JS 无法读取，抵御 XSS 脚本窃取令牌；搭配 SameSite=Lax
                  策略，限制跨站请求携带 Cookie，降低 CSRF 攻击风险，并且限定 Cookie 仅在刷新 Token
                  接口携带，遵循最小权限原则。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/login-code.webp" alt="login-code"/>
              </div>
            </div>
            <div class="mask-card">
              <div class="tips">Redis 防爆破与账号锁定</div>
              <div class="mask-text-block">
                <p>Redis记录账号密码错误次数，连续多次密码错误自动锁定账号，拦截暴力密码破解。登录成功后自动清空失败计数与锁定标记，同时缓存两份令牌，支持后台主动清除
                  Token，实现强制用户下线。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/login-error.webp" alt="login-error"/>
              </div>
            </div>
            <div class="mask-card">
              <div class="tips">
                JWT 拦截器全局接口鉴权
              </div>
              <div class="mask-text-block">
                <p>基于Filter 和 SpringMVC 拦截器统一拦截所有需要鉴权的接口，提取请求头 AccessToken，校验签名合法性、令牌有效期。解析
                  JWT 载荷，把用户身份、角色信息存入请求上下文；令牌非法 / 过期直接返回 401，拒绝访问。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/login-filter.webp" alt="login-filter"/>
              </div>
            </div>
            <div class="mask-card">
              <div class="tips">通行密钥</div>
              <div class="mask-text-block">
                <p>依托 WebAuthn 标准，以设备生物识别代替密码，跨设备同步，从根源杜绝密码泄露。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/passkey.webp" alt="passkey"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mask glass" v-if="manage" @click.self="manage=false">
        <!-- 弹窗卡片容器 -->
        <div class="mask-body">
          <!-- 右上角关闭按钮 -->
          <button class="mask-close-btn" @click="manage=false">
            <img class="detail-img" src="@/assets/svg/close.svg" alt="close"/>
          </button>
          <div class="mask-top-label">创作</div>
          <h2 class="mask-main-title">高效、方便。</h2>
          <div class="mask-cards">
            <div class="mask-card">
              <div class="tips">
                博客创作
              </div>
              <div class="mask-text-block">
                <p>支持 Markdown
                  语法撰写技术博文，内置代码块渲染、图片资源托管、预览实时渲染能力。文章可配置标题图、分类标签与简介描述，内容提交后自动持久化存储。可随时编辑、预览与管理已发布文章，沉淀技术笔记，搭建个人知识站点。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/blog-write.webp" alt="blog-write"/>
              </div>
            </div>
            <div class="mask-card">
              <div class="tips">博客管理</div>
              <div class="mask-text-block">
                <p>集中管理全站博文，支持文章查询、编辑、上下线状态控制。可修改标题、摘要、封面图与标签，随时更新 Markdown
                  正文。支持查看文章基础信息，对已发布内容进行维护，高效维护个人博客知识库。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/blog-manage.webp" alt="blog-manage"/>
              </div>
            </div>
            <div class="mask-card">
              <div class="tips">时刻创作</div>
              <div class="mask-text-block">
                <p>轻量快速发布动态时刻，简短记录技术碎片、随笔灵感。支持 Markdown
                  小段内容、图片上传，可附加标签，快速完成内容发布，用来沉淀零散想法，不用撰写完整长篇博文。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/moment-create.webp" alt="moment-create"/>
              </div>
            </div>
            <div class="mask-card">
              <div class="tips">其他管理</div>
              <div class="mask-text-block">
                <p>时刻管理、书架上新、书架管理、工具箱上新、工具箱管理，一应俱全。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/other-manage.webp" alt="moment-create"/>
              </div>
            </div>
            <div class="mask-card">
              <div class="tips">
                轻，还能更轻
              </div>
              <div class="mask-text-block">
                <p>上传图片时后端自动将原图转码为 WebP 格式。相比 JPG/PNG，WebP
                  体积大幅压缩，在保证画质的前提下减少带宽消耗，加速页面图片加载，提升博客与时刻的浏览体验。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/webp.webp" alt="webp"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
    <div class="sub-item">
      <div class="special-card light scroll-animate" style="--delay:0.3s">
        <div class="special-card-left">
          <div class="title">快速检索 <img class="detail-img" src="@/assets/svg/detail.svg" @click="openSearchMask"
                                           alt="detail">
          </div>
          <div class="description textBold">
            博客、时刻、还是全站，想搜就搜
          </div>
          <div class="description">
            依据当前页面加载对应的查询能力，快速定位内容
          </div>
        </div>
        <img class="special-card-right" src="../../assets/search.webp" alt="search"/>
      </div>
    </div>
    <Teleport to="body">
      <div class="mask glass" v-if="search" @click.self="search=false">
        <!-- 弹窗卡片容器 -->
        <div class="mask-body">
          <!-- 右上角关闭按钮 -->
          <button class="mask-close-btn" @click="search=false">
            <img class="detail-img" src="@/assets/svg/close.svg" alt="close"/>
          </button>
          <div class="mask-top-label">查询</div>
          <h2 class="mask-main-title">查询，快人一步。</h2>
          <div class="mask-cards">
            <div class="mask-card spec">
              <div class="tips">快速唤醒</div>
              <div class="mask-text-block">
                <p>快捷键<code class="keyboard-hint">Command+k</code>一键唤起搜索框，光标自动聚焦。无需手动点击输入区域，快速输入关键词检索博客、时刻、全站内容，高效查找站内内容。
                </p>
                <p>快捷键<code class="keyboard-hint">Command+Shift+k</code> 取消唤醒。</p>
                <p>Windows用户，使用<code class="keyboard-hint">Ctrl+k</code> 唤起搜索，<code class="keyboard-hint">Ctrl+Shift+k</code>
                  取消唤醒。</p>
              </div>
            </div>
            <div class="mask-card">
              <div class="tips">
                全站检索
              </div>
              <div class="mask-text-block">
                <p>全站全局搜索，站内内容一键检索。</p>
                <p>你可以搜索读书笔记、博客随笔、时刻，页面内所有可检索内容，都能快速定位，瞬间找到想要的资料。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/searchAll.webp" alt="searchAll"/>
              </div>
            </div>
            <div class="mask-card">
              <div class="tips">
                随页检索
              </div>
              <div class="mask-text-block">
                <p>
                  博客、时刻等等一站式检索，依据当前页面加载对应的查询能力，快速定位站内文章与动态。输入关键词即可检索标题、正文内容，在海量笔记里瞬间找到目标内容。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/searchBlog.webp" alt="searchBlog"/>
              </div>
            </div>
            <div class="mask-card">
              <div class="tips">全文标题检索</div>
              <div class="mask-text-block">
                <p>你以为这就完了？在博客详情页面，你甚至可以搜索指定的文章标题，并支持模糊搜索</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/search-detail.webp" alt="searchDetail"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <div class="guide-group">
      <div class="hero-description hero-big-description scroll-animate" style="--delay:0.3s">再来说点你看不到的</div>
    </div>
    <div class="sub-item">
      <div class="special-card light scroll-animate" style="--delay:0.3s">
        <div class="special-card-left">
          <div class="title">权限控制<img class="detail-img" src="@/assets/svg/detail.svg" @click="openRbacMask"
                                          alt="detail"></div>
          <div class="description textBold">
            麻雀虽小，五脏俱全。
          </div>
          <div class="description">
            基于RBAC，以账号为身份，以角色为纽带，以菜单为边界
          </div>
          <div class="description">
            —— 小小后台，权限井然。
          </div>
        </div>
        <img class="special-card-right" src="../../assets/rbac.webp" alt="rbac"/>
      </div>
    </div>
    <Teleport to="body">
      <div class="mask glass" v-if="rbac" @click.self="rbac=false">
        <!-- 弹窗卡片容器 -->
        <div class="mask-body">
          <!-- 右上角关闭按钮 -->
          <button class="mask-close-btn" @click="rbac=false">
            <img class="detail-img" src="@/assets/svg/close.svg" alt="close"/>
          </button>
          <div class="mask-top-label">权限</div>
          <h2 class="mask-main-title">角色驱动，权限随心</h2>
          <div class="mask-cards">
            <div class="mask-card">
              <div class="tips">
                分配角色
              </div>
              <div class="mask-text-block">
                <p>角色与权限解耦，不用逐个配置用户权限，新增用户直接分配角色即可，降低权限维护成本。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/role.webp" alt="role"/>
              </div>
            </div>
            <div class="mask-card">
              <div class="tips">分配菜单</div>
              <div class="mask-text-block">
                <p>
                  为角色分配前端菜单，不同身份用户仅能看到权限范围内的导航入口，隐藏无访问权限菜单，简化界面同时保障安全。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/menu.webp" alt="menu"/>
              </div>
            </div>
            <div class="mask-card">
              <div class="tips">接口鉴权</div>
              <div class="mask-text-block">
                <p>全局统一接口鉴权，自动校验请求身份与访问权限，拦截非法越权调用，保护后端数据安全。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/auth.webp" alt="auth"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <div class="sub-item">
      <div class="special-card light scroll-animate" style="--delay:0.3s">
        <div class="special-card-left">
          <div class="title">哨兵<img class="detail-img" src="@/assets/svg/detail.svg" @click="openMonitorMask"
                                      alt="detail"></div>
          <div class="description textBold">
            细微异动，及时捕捉。
          </div>
          <div class="description">
            数据可视化直观呈现，让站点运行状态一目了然。
          </div>
        </div>
        <img class="special-card-right" src="../../assets/monitor.webp" alt="monitor"/>
      </div>
    </div>
    <Teleport to="body">
      <div class="mask glass" v-if="monitor" @click.self="monitor=false">
        <!-- 弹窗卡片容器 -->
        <div class="mask-body">
          <!-- 右上角关闭按钮 -->
          <button class="mask-close-btn" @click="monitor=false">
            <img class="detail-img" src="@/assets/svg/close.svg" alt="close"/>
          </button>
          <div class="mask-top-label">哨兵</div>
          <h2 class="mask-main-title">细微异动，及时捕捉。</h2>
          <div class="mask-cards">
            <div class="mask-card">
              <div class="tips">
                菜单访问量统计
              </div>
              <div class="mask-text-block">
                <p>
                  统计各菜单访问次数，记录页面访问行为，直观了解后台模块使用热度，辅助后台功能迭代优化；ECharts图标支持接口下钻。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/db.webp" alt="db"/>
              </div>
            </div>
            <div class="mask-card">
              <div class="tips">异常统计</div>
              <div class="mask-text-block">
                <p>自动收集系统异常日志，统计报错频次，快速识别异常波动，便于排查接口、服务故障，保障站点稳定运行。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/monitor-code.webp" alt="monitor-code"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
    <div class="sub-item">
      <div class="special-card light scroll-animate" style="--delay:0.3s">
        <div class="special-card-left">
          <div class="title">联系我</div>
          <div class="description textBold">
            方寸站点，自成天地。
          </div>
          <div class="description">
            欢迎来到天空之城。世界很大，文字很短。
          </div>
          <div class="description">
            如果你愿意，不妨留下你的声音。
          </div>
        </div>
        <img class="special-card-right" src="../../assets/withMe.webp" alt="withMe"/>
      </div>
    </div>
    <div class="sub-item">
      <div class="hero-description  hero-big-description scroll-animate" style="--delay:0.3s">上层繁花，底层承重<!--<img
          class="detail-img" src="@/assets/svg/detail.svg" @click="openOpsMask">--></div>
      <div class="hero-description  hero-description-subTitle scroll-animate" style="--delay:0.3s">基于Docker Compose
        容器编排，前后端技术栈协同支撑全站能力
      </div>
    </div>
    <Teleport to="body">
      <div class="mask glass" v-if="ops" @click.self="ops=false">
        <!-- 弹窗卡片容器 -->
        <div class="mask-body">
          <!-- 右上角关闭按钮 -->
          <button class="mask-close-btn" @click="ops=false">
            <img class="detail-img" src="@/assets/svg/close.svg" alt="close"/>
          </button>
          <div class="mask-top-label">技术栈</div>
          <h2 class="mask-main-title">好的网站，好的技术</h2>
          <div class="mask-cards">
            <div class="mask-card">
              <div class="tips">
                菜单访问量统计
              </div>
              <div class="mask-text-block">
                <p>统计各菜单访问次数，记录页面访问行为，直观了解后台模块使用热度，辅助后台功能迭代优化。</p>
              </div>
              <div class="mask-img-block">
                <img src="@/assets/db.webp" alt="db"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
    <div class="card-marquee">
      <!-- 2. 内层滚动轨道：你自己的卡片直接放这里就行 -->
      <div class="card-marquee-track">
        <!-- 你原有的卡片，不需要改任何样式 -->
        <div class="card">
          <img src="@/assets/svg/java.svg" alt="java"/>
        </div>
        <div class="card">
          <img src="@/assets/svg/spring.svg" alt="spring"/>
        </div>
        <div class="card">
          <img src="../../assets/svg/springBoot.svg" alt="springBoot"/>
        </div>
        <div class="card">
          <img src="../../assets/svg/springCloud.svg" alt="springCloud"/>
        </div>
        <div class="card">
          <img src="@/assets/svg/mybatis.svg" alt="mybatis"/>
        </div>
        <div class="card">
          <img src="@/assets/svg/nginx.svg" alt="nginx"/>
        </div>
        <div class="card">
          <img src="@/assets/svg/redis.svg" alt="redis"/>
        </div>
        <div class="card">
          <img src="@/assets/svg/mysql.svg" alt="mysql"/>
        </div>
        <div class="card">
          <img src="@/assets/svg/mongo.svg" alt="mongo"/>
        </div>
        <div class="card">
          <img src="@/assets/svg/minio.svg" alt="minio"/>
        </div>
        <div class="card">
          <img src="@/assets/svg/docker.svg" alt="docker"/>
        </div>
        <div class="card">
          <img src="@/assets/svg/javascript.svg" alt="javascript.svg"/>
        </div>
        <div class="card">
          <img src="@/assets/svg/css.svg" alt="css"/>
        </div>
        <div class="card">
          <img src="@/assets/svg/vue.svg" alt="vue"/>
        </div>
        <div class="card">
          <img src="@/assets/svg/qoder.svg" alt="qoder"/>
        </div>
        <div class="card">
          <img src="@/assets/svg/chatgpt.svg" alt="chatgpt"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {useScrollHeader} from "@/hooks/useScrollHeader";
import {onMounted, onUnmounted, ref} from "vue";

const login = ref(false);
const manage = ref(false);
const search = ref(false);
const rbac = ref(false);
const monitor = ref(false);
const ops = ref(false);
const openLoginMask = () => {
  login.value = true;
}
const openManageMask = () => {
  manage.value = true;
}
const openSearchMask = () => {
  search.value = true;
}
const openRbacMask = () => {
  rbac.value = true;
}
const openMonitorMask = () => {
  monitor.value = true;
}

useScrollHeader()
let observer = null;
onMounted(async () => {
  trackFn()
  // 滚动动画监听
  observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (entry.isIntersecting) {
          entry.target.classList.add('active')
          observer.unobserve(entry.target) // 只播放一次，不再重复触发
        }
      }
    })
    }, {
      threshold: 0.05, // 元素15%进入视口就触发动画
    })
    document.querySelectorAll('.scroll-animate').forEach(el => {
      observer.observe(el)
    })
  })
  onUnmounted(() => {
    observer?.disconnect()
  })

  const trackFn = () => {
    const track = document.querySelector('.card-marquee-track');
    if (track) {
      track.append(...Array.from(track.children).map(node => node.cloneNode(true)));
    }
  }
</script>

<style scoped>
.product-banner1 {
  background: var(--laputa-body-background-other);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: fit-content;
  overflow: hidden;
  position: relative;
  min-height: 100vh;
  width: 100%;
}

.banner-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: static;
}

.product-banner1 span.title {
  font-size: var(--laputa-fontsize-100);
  color: var(--laputa-common-font-color);
  font-weight: 600;
  text-align: center;
  line-height: 64px;
  margin-top: 12px;
  justify-self: center;
}

.banner-description-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0.8;
  margin: 24px 0 32px 0;
  padding: 20px 0 0 0;
  z-index: 2;
}

.banner-info span.description {
  font-size: 20px;
  color: var(--laputa-common-secondary-font-color);
  text-align: center;
}

.next-hero,
.sub-item {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.sub-item {
  width: 90%;
  margin-bottom: 100px;
}

.next-hero {
  height: 100%;
  background-color: var(--laputa-body-background);
  padding: 80px;
  gap: 20px;
}

.text-card {
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
  max-width: 1200px;
}

.text-card-single {
  width: 100%;
  max-width: 1200px;
}

.text-card-single .text-group {
  width: 100%;
  min-height: 220px;
  box-sizing: border-box;
}

.text-group-card {
  flex: 1;
  background: var(--laputa-body-background-other);
  padding: 54px 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
  min-height: 220px;
}

.text-group {
  flex: 1;
  border-radius: 30px;
  background: var(--laputa-body-background-other);
  padding: 54px 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
  min-height: 320px;
}

.guide-group {
  margin-top: 20px;
  margin-bottom: 100px;
}

.hero-description {
  margin-top: 8px;
  max-width: 100%;
  letter-spacing: 0.02em;
  background: var(--laputa-common-font-color);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-align: center;
  z-index: 40;
  display: flex;
  gap: 20px;
}

.hero-big-description {
  font-size: 54px;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 50px;
  text-align: center;
}

.hero-description-title {
  font-size: 34px;
  font-weight: 600;
  line-height: 1.25;
  text-align: center;
}

.hero-description-subTitle {
  font-size: 19px;
  font-weight: 400;
  line-height: 1.6;
  color: var(--laputa-common-sub-font-color);
  text-align: center;
  margin: 0;
}

.resume-page {
  animation: page-fade-in 0.4s ease-out;
  padding-bottom: 80px;
  background-color: var(--laputa-body-background);
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.avatar-block h2 {
  margin: 0 0 4px;
  font-size: 22px;
}

.text-content p {
  line-height: 1.7;
  color: #333;
  margin: 0;
}

.card-1 {
  --delay: 0.1s;
  position: relative;
  overflow: hidden;
}

.card-1::before {
  content: "";
  position: absolute;
  inset: 0;
  /*background-image: url("@/assets/site-background.webp");*/
  background-size: cover;
  background-position: center;
  opacity: 0.12;
  z-index: 0;
}

.card-1 > * {
  position: relative;
  z-index: 1;
}

@keyframes card-fade-up {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes page-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* ========== 移动端适配 860px ========== */
@media (max-width: 860px) {
  :deep(html), :deep(body) {
    overflow-x: hidden !important;
  }

  .resume-header h1 {
    font-size: 28px;
  }

  .card {
    padding: 16px;
    margin-bottom: 16px;
    border-radius: 18px;
  }

}

.special-card-first {
  border-radius: 30px;
  position: relative;
  display: flex;
  align-self: center;
  flex-direction: column;
  justify-content: space-between; /* 上下两块自动贴顶贴底 */
  height: 700px;
  background: var(--laputa-body-background-other);
}

.special-card-up {
  display: flex;
  flex-direction: column;
  padding: 48px 48px 40px;
}

.special-card {
  border-radius: 30px;
  position: relative;
  display: flex;
  align-self: center;
  max-height: 800px;
  width: 80%;
  background: var(--laputa-body-background-other);
}

.light {
  height: 500px;
  gap: 10px;
  justify-content: space-between;
}

.first {
  gap: 20px;
  background: none;
}


.special-card-left {
  display: flex;
  flex-direction: column;
  padding: 48px 48px 40px;
}

.special-card-right {
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  z-index: 0;
  min-width: 0;
  object-fit: contain
}

.title {
  font-size: var(--laputa-fontsize-40);
  font-weight: bold;
  line-height: 1.2;
  margin-top: 8px;
  color: var(--laputa-common-font-color);
  display: flex;
  align-items: center;
  gap: 20px;
  z-index: 2;
}

.detail-img {
  cursor: pointer;
}

.detail-img:hover {
  transform: scale(1.05);
}

.textBold {
  font-weight: 800;
  color: var(--laputa-common-sub-font-color);
}

.description {
  font-size: 19px;
  margin-top: 20px;
  opacity: 0.8;
  line-height: 1.5;
  color: var(--laputa-common-secondary-font-color);
  max-width: 720px;
}

.special-card-down {
  /* 0=禁止放大，1=允许缩小，基础最大宽度420px */
  min-width: 0; /* ✅ flex布局解决图片溢出的关键！很多人漏掉这个 */
  max-width: 800px;
}

.image {
  width: 100%;
}

/* 跑马灯外层容器 */
.card-marquee {
  width: 100%;
  overflow: hidden;
  position: relative;
  mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
  padding: 10px 0; /* 可选：防止卡片阴影被裁剪 */
}

/* 滚动轨道 */
.card-marquee-track {
  display: flex;
  gap: 20px; /* 卡片之间的间距，自己调整 */
  width: fit-content; /* 关键：让轨道宽度刚好包裹所有卡片，不要设100% */
  animation: cardScroll 20s linear infinite; /* 20s是滚动一圈的时长，卡片多就调大，速度更均匀 */
  will-change: transform; /* 性能优化：提前告知浏览器做动画加速 */
  transform: translateZ(0); /* 强制开启硬件加速 */
  backface-visibility: hidden; /* 隐藏背面，减少闪烁 */
}

/* 你的原有卡片，只要加这一行防止被压缩即可，其他样式不用改 */
.card {
  flex-shrink: 0; /*必加！不然flex会把卡片挤变形 */
  /* 👇 以下是示例卡片样式，替换成你自己的卡片样式即可 */
  width: 150px;
  height: 150px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  border-radius: 25px;
  object-fit: contain;
}

/* 悬停暂停动画（可选，非常实用） */
.card-marquee:hover .card-marquee-track {
  animation-play-state: paused;
}

/* 滚动动画：永远移动50%宽度，自动适配任意卡片数量、任意屏幕宽度 */
@keyframes cardScroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* 滚动入场动画 */
.scroll-animate {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.7s ease-out;
  transition-delay: var(--delay, 0s);
}

.scroll-animate.active {
  opacity: 1;
  transform: translateY(0);
}

.text-group-card-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  border-radius: 30px;
  background: var(--laputa-body-background-other);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
  min-height: 320px;
  overflow: hidden;
}

.text-group-image {

}

.text-group-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.mask {
  position: fixed;
  inset: 0;
  /* 毛玻璃背景 */
  background: var(--laputa-card-background-deep-mask-gray);
  backdrop-filter: blur(16px);
  overflow-y: auto;
  overscroll-behavior: contain;
  /* 水平居中，垂直方向：内容短就居中；内容长就顶部开始往下流 */
  display: flex;
  justify-content: center;
  padding: 40px 20px;
  box-sizing: border-box;
  z-index: 99;
}

.mask-body {
  position: relative;
  background: var(--laputa-body-background-other);
  border-radius: 24px;
  /* 最大宽度：屏幕减去左右边距 */
  width: calc(100% - 80px);
  min-height: fit-content;
  padding: 48px;
  box-sizing: border-box;
}

/* 右上角关闭按钮 */
.mask-close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--laputa-body-background-other);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
}

.mask-top-label {
  font-size: var(--laputa-fontsize-16);
  color: #666;
  margin-bottom: 12px;
}

.mask-main-title {
  font-size: 52px;
  font-weight: 600;
  margin: 0 0 32px 0;
  line-height: 1.15;
  color: var(--laputa-common-sub-font-color);
}

.mask-text-block {
  font-size: 20px;
  color: var(--laputa-common-sub-font-color);
  line-height: 1.6;
  max-width: 720px;
}

.mask-text-block p {
  text-align: center;
}

.mask-cards {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 50px;
}

.mask-card {
  padding-top: 40px;
  background: var(--laputa-body-background);
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.spec {
  background: var(--laputa-body-background-other);
}

.mask-img-block {
  width: 100%;
}

.mask-img-block img {
  width: 100%;
  display: block;
  object-fit: contain;
}

.tips {
  color: var(--laputa-yellow);
  font-size: var(--laputa-fontsize-14);
}

.keyboard-hint {
  color: #2563eb;
  font-weight: 500;
  background: rgba(37, 99, 235, 0.08);
  padding: 2px 6px;
  border-radius: 4px;
  margin-right: 5px;
  margin-left: 5px;
}

</style>
